<selfai-platform-img-with-auth [src]="imgSrc" [class.defaultstyle]="defaultSrc" />
